import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Role } from '@ra-state';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-ag-role-badge-renderer',
  template: ` <span class="role-badge" [ngClass]="badgeCssClass">{{ displayRole }}</span> `,
  styleUrls: ['./ag-role-badge-renderer.component.scss'],
})
export class AgRoleBadgeRendererComponent implements ICellRendererAngularComp {
  role = '';
  displayRole = '';
  badgeCssClass = '';

  agInit(params: ICellRendererParams): void {
    this.role = params.value || '';
    this.displayRole = params.value === Role.Navigator ? 'None' : params.value || 'None';
    this.badgeCssClass = this.getBadgeClass(this.role);
  }

  refresh(): boolean {
    return false;
  }

  private getBadgeClass(role: string): string {
    switch (role) {
      case Role.Owner:
        return 'badge-owner';
      case Role.Admin:
        return 'badge-admin';
      case Role.Contributor:
        return 'badge-contributor';
      default:
        return 'badge-none';
    }
  }
}
